<template>
  <div class="logos">
    <a href="https://www.embo.org/" target="_blank" rel="nofollow">
      <img src="./img/embo.png" alt="EMBO" title="EMBO" />
    </a>
    <a href="https://www.embl.de/" target="_blank" rel="nofollow">
      <img src="./img/embl.png" alt="EMBL" title="EMBL" />
    </a>
  </div>
</template>

<style scoped>
.logos {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
}
img {
  height: clamp(20px, 8vw, 55px);
  width: auto;
}
</style>
